import axios from "axios";
import { API_URL, getAuthHeader, getPDFAuthHeader } from ".";
import { ResponseModel } from "../Models/ResponseModel";
import { User } from "../Models/User";
import { Member } from "../Models/Member";
import { Favorites } from "../Models/Favorites";
import { ResetPasswordRequest } from "../Models/ResetPasswordRequest";
import { UserListRequest } from "../Models/UserListRequest";

class UserApi {
  static getUser(id: string) {
    return axios.get<User>(`${API_URL}/api/user/${id}`, getAuthHeader());
  }
  static deleteUser(id: number) {
    return axios.get<ResponseModel>(
      `${API_URL}/api/user/${id}/delete`,
      getAuthHeader()
    );
  }
  static getUserPublic(id: string) {
    return axios.get<User>(`${API_URL}/api/user/${id}/public`);
  }
  static addUpdateUser(request: User) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user`,
      request,
      getAuthHeader()
    );
  }
  static uploadUserImage(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/imageupload`,
      request,
      getAuthHeader()
    );
  }
  static getUserFavoritesMembers() {
    return axios.get<Member[]>(
      `${API_URL}/api/user/getUserFavoritesMembers`,
      getAuthHeader()
    );
  }
  static getUserFavoritesUsers() {
    return axios.get<User[]>(
      `${API_URL}/api/user/getUserFavoritesUsers`,
      getAuthHeader()
    );
  }
  static getUserFavorites() {
    return axios.get<Favorites[]>(
      `${API_URL}/api/user/getUserFavorites`,
      getAuthHeader()
    );
  }
  static updatePassword(userId: number, request: ResetPasswordRequest) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/updatepassword/${userId}`,
      request,
      getAuthHeader()
    );
  }
  static getUserBadge(userId: number) {
    return axios.get(
      `${API_URL}/api/Reports/GetUserBadge/${userId}`,
      getPDFAuthHeader()
    );
  }
  static getUserBadgeList(userList: User[]) {
    return axios.post(
      `${API_URL}/api/Reports/GetUserBadgeList`,
      userList,
      getPDFAuthHeader()
    );
  }
  static getFEMAMemberUserList() {
    return axios.get<User[]>(
      `${API_URL}/api/user/femauserlist`,
      getAuthHeader()
    );
  }

  /** All users (filtered by request). Used by superusers on the user list page. */
  static getUserList(request: UserListRequest) {
    return axios.post<User[]>(
      `${API_URL}/api/user/list`,
      request,
      getAuthHeader()
    );
  }
  static updateFEMAFields(userId: number, patch: Partial<User>) {
    return axios.put(
      `${API_URL}/api/user/${userId}/fema`,
      patch,
      getAuthHeader()
    );
  }

  static sendFemaEmail(userId: number) {
    const auth = getAuthHeader();
    return axios.post(`${API_URL}/api/user/${userId}/send-fema-email`, null, {
      headers: { ...(auth.headers ?? auth) },
    });
  }
  static sendFemaEmailTest(userId: number) {
    const auth = getAuthHeader();
    return axios.post(
      `${API_URL}/api/user/${userId}/send-fema-email-test`,
      null,
      {
        headers: { ...(auth.headers ?? auth) },
      }
    );
  }
  static sendFemaEmailBulk(userIds: number[]) {
    const auth = getAuthHeader();
    return axios.post(
      `${API_URL}/api/user/send-fema-email-bulk`,
      { userIds },
      {
        headers: {
          ...(auth.headers ?? auth),
          "Content-Type": "application/json",
        },
      }
    );
  }
}

export default UserApi;
